import React from "react";
import { useState } from "react";
import Godigit from '../Images/go-digit.png';
import '../HomePage/Quotes.css';
import '../HomePage/HomeInsurance.css';
import { CommaSeprator } from "./UtilityComponents/UilityFunctions";

const HomePlan = ({ QuoteRes, QuoteReq }) => {

    return (
        <>
            <div className="Home_plan">
                <div className="homeplane">
                    <div className="go-digit">
                        <img src={QuoteRes?.image} className="enquiry_img" alt="Go digit"/>
                    </div>
                    <div className="Plans">
                        <h6>{QuoteRes?.planName}</h6>
                    </div>
                </div>
                <div className="_homeEnq">
                    <span>Enquiry#</span>
                    <span>{QuoteReq?.EnquiryNo}</span>
                </div>
                <div className="pre_amount">
                    <div className="pre_amount1">
                        <p className="mb-1">Inculded Addons Amount</p>
                        <span>₹{CommaSeprator(Math.round(QuoteRes?.includedResultAddons))}</span>
                    </div>
                    <div className="pre_amount1">
                        <p className="mb-1">Premium Amount</p>
                        <span>₹{CommaSeprator(Math.round(QuoteRes?.netPremium))}</span>
                    </div>
                    <div className="pre_amount1">
                        <p className="mb-1">+ GST</p>
                        <span>₹{CommaSeprator(Math.round(QuoteRes?.serviceTax))}</span>
                    </div>
                   
                </div>
                <div className="total_amount">
                    <div className="total_amount1">
                        <p className="mb-1">Premium Amount</p>
                        <span>₹{CommaSeprator(Math.round(QuoteRes?.totalPremium))}</span>
                    </div>
                </div>
            </div>
        </>
    );
}
export default HomePlan;